import { Controller } from "@hotwired/stimulus"

// Master checkbox on summary Games tab: toggles all game_ids checkboxes in the same form.
export default class extends Controller {
  toggleAll(event) {
    const checked = event.currentTarget.checked
    this.element.querySelectorAll('input[type="checkbox"][name*="game_ids"]').forEach((input) => {
      input.checked = checked
    })
  }
}
